import BaseAPI from './base';

class DemarcheDocumentsAPI extends BaseAPI {
  index(slug: string, token: string) {
    return this.get(`/api/web/v1/demarches/${slug}/orders/${token}/documents`, {});
  }

  create(slug: string, token: string, documentKey: string, file: File) {
    const formData = new FormData();
    formData.append('document_key', documentKey);
    formData.append('file', file);
    return this.postFormData(`/api/web/v1/demarches/${slug}/orders/${token}/documents`, formData);
  }

  destroy(slug: string, token: string, id: string) {
    return this.delete(`/api/web/v1/demarches/${slug}/orders/${token}/documents/${id}`, {});
  }
}

export default new DemarcheDocumentsAPI();
